module.exports = __webpack_public_path__ + "static/media/logo_1.c47cb1c5.svg";